import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

export default function ConfirmDialog(props) {
  const { open, title, message, onClose, onConfirm } = props;

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle id="simple-dialog-title">
        { title || 'Confirm' }
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          { message || 'Do you confirm the operation?' }
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="secondary">Cancel</Button>
        <Button onClick={onConfirm} color="primary" autoFocus>Confirm</Button>
      </DialogActions>
    </Dialog>
  );
};
